// extracted by mini-css-extract-plugin
module.exports = {"gridWishlist":"wishlist_gridWishlist__2r-oY"};